import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Button.module.scss';

export const Button = ({
  href,
  htmlType,
  type,
  children,
  className,
  target,
  onClick,
}) => {
  const handleClick = () => onClick && onClick();

  if (href) {
    return (
      <a
        target={target}
        href={href}
        className={cn(
          {
            [styles.link]: type === 'link',
            [styles.button]: type === 'button',
          },
          className,
        )}
        onClick={handleClick}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={htmlType}
      className={cn(
        {
          [styles.link]: type === 'link',
          [styles.button]: type === 'button',
        },
        className,
      )}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  href: PropTypes.string,
  htmlType: PropTypes.oneOf(['submit', 'reset', 'button']),
  type: PropTypes.oneOf(['link', 'button']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  href: null,
  htmlType: 'button',
  type: 'button',
  className: null,
  target: null,
  onClick: () => null,
};
